import React, { FC } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import ResponseEntity from '../../../store/polls-store/response-entity';
import PollResponseListItem from './poll-response-list-item';

interface IProps {
  response: ResponseEntity;
  index: number;
  deleteResponseById: (id: string) => void;
  validation: (isValid: boolean) => void;
}

const PollResponseDraggable: FC<IProps> = ({ response, index, deleteResponseById, validation }) => {
  return (
    <Draggable
      draggableId={response.pollChoiceId}
      index={index}
    >
      {(provided) => (
        <div
          className='manage-poll-response-filled'
          ref={provided.innerRef}
          {...provided.draggableProps}
          { ...provided.dragHandleProps}
        >
          <PollResponseListItem
            response={response}
            deleteResponseById={deleteResponseById}
            validation={validation}
          />
        </div>
      )}
    </Draggable>
  );
};

export default PollResponseDraggable;
